import React from "react";
import {observer} from "mobx-react-lite";
import {Table, TableBody, TableFooter, TablePagination, TableRow} from "@mui/material";
import {ParentSupplierReviewSubRow} from "./ParentSupplierReviewSubRow";
import {CurrencyAbbreviationContext} from "../../../../components/currency-component/CurrencyAbbreviationContext";
import type {ParentSupplierReviewRow} from "../SupplierNormalization.classes";
import {MithraTableHeadColumns} from "../../../../components/table/MithraTableHeadColumns";
import {getSupplierNormalizationSupplierColumns} from "./columns";
import {useStores} from "../../../../stores";
import {MithraTablePaginationActions} from "../../../../components/table-pagination/MithraTablePaginationActions";
import {findAbbreviation} from "../../../../components/currency-component/CurrencyClasses";

type Props = {
    parentSupplier: ParentSupplierReviewRow
};
export const ParentSupplierReviewSubTable: React.FC<Props> = observer(({parentSupplier}) => {
    const {supplierNormalizationStore, p, authStore} = useStores();
    const SUPPLIER_COLUMNS = getSupplierNormalizationSupplierColumns(p, authStore);

    return <Table
        className="sub-table"
        size="small">
        <MithraTableHeadColumns columns={SUPPLIER_COLUMNS} enableLoading
                                isLoading={supplierNormalizationStore.supplierRM.busy}/>
        <TableBody>
            {supplierNormalizationStore.supplierRM.result?.results?.map(supplier =>
                <React.Fragment key={supplier.id}>
                    <CurrencyAbbreviationContext.Provider value={findAbbreviation(parentSupplier.sp_total_spend)}>
                        <ParentSupplierReviewSubRow supplier={supplier} parentSupplier={parentSupplier}/>
                    </CurrencyAbbreviationContext.Provider>
                </React.Fragment>
            )}
        </TableBody>
        <TableFooter>
            <TableRow>
                <TablePagination
                    colSpan={SUPPLIER_COLUMNS.length}
                    count={supplierNormalizationStore.supplierRM.result?.count ?? 0}
                    rowsPerPage={parseInt(supplierNormalizationStore.supplierFilters.filters.find(i => i[0] === 'page_size')?.at(1) ?? '10')}
                    page={parseInt(supplierNormalizationStore.supplierFilters.filters.find(i => i[0] === 'page')?.at(1) ?? '1') - 1}
                    onPageChange={(event, page: number) => {
                        supplierNormalizationStore.supplierFilters.setFilters([['page', (page + 1).toString()]]);
                    }}
                    onRowsPerPageChange={(event) => {
                        supplierNormalizationStore.supplierFilters.setFilters([['page_size', (event.target.value).toString()]], false);
                        supplierNormalizationStore.supplierFilters.setFilters([['page', '1']]);
                    }}
                    ActionsComponent={MithraTablePaginationActions}
                />
            </TableRow>
        </TableFooter>
    </Table>
})
